import { CartImpressionTrackingInfoItem } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsRemoveFromCartImpression
    extends GoogleAnalyticsMinimumDataset {
    ecommerce: {
        currencyCode: string;
        remove: {
            products: GoogleAnalyticsProduct[];
        };
    };
}

const getGoogleAnalyticsRemoveFromCartImpression = (
    data: EnrichedAnalyticsEvent<CartImpressionTrackingInfoItem>
): GoogleAnalyticsRemoveFromCartImpression => {
    const googleAnalyticsCommerce: GoogleAnalyticsProduct =
        getGoogleAnalyticsProduct(data.payload.eventData);

    return {
        event: GoogleAnalyticsEvents.ProductRemoveFromCart,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        ecommerce: {
            currencyCode: data.payload.eventData.currencyCode,
            remove: {
                products: [
                    {
                        ...googleAnalyticsCommerce,
                        quantity: data.payload.eventData.quantity
                    }
                ]
            }
        }
    };
};

export { getGoogleAnalyticsRemoveFromCartImpression };
